import { useState, useEffect } from 'react';
import { Outlet } from 'react-router-dom';
import { Slide, ToastContainer } from 'react-toastify';
import Sidebar from './components/CommonComponents/Sidebar';
import Header from './components/CommonComponents/Header';
import ServiceDisruptionBanner from './components/CommonComponents/ServiceDisruptionBanner';
import OnboardingTour from './components/Onboarding/OnboardingTour';

const Layout = () => {
  const [darkMode, setDarkMode] = useState(false);

  useEffect(() => {
    // Check for saved dark mode preference or default to light mode
    const savedMode = localStorage.getItem('darkMode');
    const isDark = savedMode === 'true';
    setDarkMode(isDark);
    updateDarkMode(isDark);
  }, []);

  const updateDarkMode = (isDark: boolean) => {
    const html = document.documentElement;
    const body = document.body;
    
    if (isDark) {
      html.classList.add('dark');
      body.classList.add('dark');
      html.style.colorScheme = 'dark';
    } else {
      html.classList.remove('dark');
      body.classList.remove('dark');
      html.style.colorScheme = 'light';
    }
  };



  return (
    <div className={`min-h-screen flex transition-colors duration-200 h-screen`}>
      {/* Sidebar */}
      <Sidebar />
      
      {/* Main Content */}
      <div className="flex-1 flex flex-col lg:ml-0 h-screen overflow-hidden">
        <ServiceDisruptionBanner />
        {/* Header */}
        <Header />
        <OnboardingTour />
        
        <main className={`flex-grow bg-gray-100 dark:bg-gray-900 lg:p-6 sm:p-1 text-gray-900 dark:text-gray-100 overflow-scroll`}>
          <Outlet />
        </main>
      </div>
      
      <ToastContainer
        position="top-center"
        autoClose={5000}
        hideProgressBar={false}
        newestOnTop={false}
        closeOnClick={false}
        rtl={false}
        pauseOnFocusLoss
        draggable
        pauseOnHover={false}
        theme={darkMode ? "dark" : "light"}
        transition={Slide}
      />
    </div>
  );
};

export default Layout;
